import isChatCommerce from './isChatCommerce'
import gql from 'graphql-tag'
import {useApolloQuery} from '@packages/apollo-hooks'
import {
  getWhatsAppCommerceNumber,
  getWhatsAppCommerceNumberVariables
} from '@page-components/Order/Cart/Content/__generated__/getWhatsAppCommerceNumber'

export default function useWhatsAppCommerceNumber(websiteId, preferences) {
  const {website} = useApolloQuery<getWhatsAppCommerceNumberVariables, getWhatsAppCommerceNumber>({
    query: gql`
      query getWhatsAppCommerceNumber($websiteId: ID) {
        website(websiteId: $websiteId) {
          _id
          whatsappChatCommerceNumber
        }
      }
    `,
    variables: {websiteId},
    omit: !isChatCommerce(preferences)
  })

  return website ? website.whatsappChatCommerceNumber : null
}
